/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useForm} from 'react-hook-form'
import {useAuth} from 'context/AuthProvider'
import {
 getApiCall,
 postApiCall,
} from 'utils/api/httpService'
// import {AuthContext} from '@context/AuthProvider'
import {setcommonFilterData} from '../../redux/reducer/commonFilterReducer'
import {
 Select2DropdownField,
 TextField,
 RadioButtonField,
 DatePickerField,
 TextareaField,
 Button,
} from '../index'
import moment from 'moment'
import {ToggleButtonField} from './form/ToggleButtonField'
import {IFormField} from 'models/Common'
import {useTranslation} from 'react-i18next'

const GenericFilters = (props: any) => {
 const {t} = useTranslation()
 const dispatch = useDispatch()
 const {userData}: IFormField = useAuth()
 const commonFilterReducer: any = useSelector(
  (state: any) => state?.commonFilterReducer
 )
 const [dependentFieldMapping, setDependentFieldMapping] =
  useState<any | null>(null)
 const [filterKeyValueMapping, setFilterKeyValueMapping] =
  useState<any | null>(null)
 const [dropdownList, setDropdownList] = useState<
  any | null
 >({})

 const [selectedBox, setSelectedBox] = useState('')

 const {
  handleSubmit,
  register,
  control,
  setValue,
  reset,
  watch,
  formState: {errors},
 } = useForm({
  mode: 'onBlur',
  reValidateMode: 'onChange',
  defaultValues: {...props.formData},
 })

 const fetchData = async (
  childField: any,
  fieldId: any,
  value: any
 ) => {
  const dataSource = childField.fieldMetadata.dataSource
  const apiUrl = dataSource.apiUrl
  const requestType = dataSource.requestType
  const params: any = {}
  let checkForNull = false
  dataSource?.params?.map((parm: any) => {
   params[parm.paramId] = ''
   if (parm?.fieldId) {
    if (parm?.fieldId == fieldId) {
     params[parm.paramId] = value
    } else {
     const fieldObj = filterKeyValueMapping?.[parm?.fieldId]
     if (fieldObj) {
      params[parm.paramId] = watch(fieldObj.fieldId)
     }
    }
   } else if (parm?.isConfig) {
    params[parm.paramId] = userData?.[parm?.configId]
   } else {
    params[parm.paramId] = parm.value
   }
   if (
    (Array.isArray(params[parm.paramId]) &&
     params[parm.paramId].length == 0) ||
    params[parm.paramId] === ''
   ) {
    checkForNull = true
   } else {
    params[parm.paramId] = params[parm.paramId].toString()
   }
  })
  let res: any = []
  if (!checkForNull) {
   props.setLoader(true)
   if (requestType === 'GET') {
    res = await getApiCall(apiUrl, {...params})
   } else if (requestType === 'POST') {
    res = await postApiCall(apiUrl, {...params})
   } else {
    res = await getApiCall(apiUrl, {...params})
   }
   props.setLoader(false)
  }

  return dataSource?.responseKey
   ? res?.[dataSource.responseKey] || []
   : res || []
 }

 function onChangeBox(boxName: any) {
  setSelectedBox(boxName)
 }

 function applyFilter(data: any) {
  props.setFormData(data)
  props.applyFilter()
 }

 const createForm = async () => {
  const dropdownData = {...dropdownList}
  const fieldKeyValueMapping = {...filterKeyValueMapping}
  const dependentFieldMappings = {...dependentFieldMapping}
  for (const field of props.filterConfig) {
   const ddKey = props.parentId + '_' + field.fieldId
   fieldKeyValueMapping[field.fieldId] = field
   const datasource: any = field.fieldMetadata?.dataSource
   if (datasource) {
    if (
     datasource.source === 'inline' &&
     (datasource?.data || datasource?.options)
    ) {
     dropdownData[ddKey] = datasource?.data
      ? datasource.data
      : datasource.options
    } else if (
     datasource?.onLoadCall &&
     datasource.source == 'api'
    ) {
     if (commonFilterReducer?.data?.[ddKey]?.length > 0) {
      dropdownData[ddKey] = commonFilterReducer.data[ddKey]
     } else {
      const res: any = await fetchData(
       field,
       field.fieldId,
       ''
      )
      if (res && res.length > 0) {
       const reduxData: any = {}
       reduxData[ddKey] = res
       dispatch(setcommonFilterData({...reduxData}))
       dropdownData[ddKey] = res
      }
     }
    } else {
     dropdownData[ddKey] =
      props?.dropdown?.[datasource?.configKey]
    }
   }
   if (field.fieldMetadata?.dependentFieldId) {
    dependentFieldMappings[
     field.fieldMetadata.dependentFieldId
    ] = field.fieldId
   }
  }
  setDropdownList(dropdownData)
  setDependentFieldMapping(dependentFieldMappings)
  setFilterKeyValueMapping(fieldKeyValueMapping)
 }

 useEffect(() => {
  void createForm()
  setSelectedBox(props.filterConfig?.[0]?.fieldId)
 }, [props.filterConfig])

 function getDefaultValue(inputType: any) {
  let value: any = ''
  switch (inputType) {
   case 'MULTI_SELECT_DROPDOWN':
   case 'CHECK_BOX':
    value = []
    break
   default:
    value = ''
  }
  return value
 }

 const buildEmptyFormData = () => {
  const emptyData: any = {}
  for (const field of props.filterConfig) {
   emptyData[field.fieldId] = getDefaultValue(
    field.fieldMetadata?.inputType
   )
   if (
    field.fieldMetadata?.inputType ===
     'DATE_RANGE_PICKER' &&
    field.fieldMetadata?.toDateFieldId
   ) {
    emptyData[field.fieldMetadata.toDateFieldId] = ''
   }
  }
  return emptyData
 }

 const clearAllFilters = () => {
  const emptyData = buildEmptyFormData()
  const clearedData = {
   ...emptyData,
   ...(props.formData?.from_date != null && {
    from_date: props.formData.from_date,
   }),
   ...(props.formData?.to_date != null && {
    to_date: props.formData.to_date,
   }),
  }
  reset(emptyData)
  props.setFormData(clearedData)
  props.applyFilter()
 }

 const handleChange = async (field: any) => {
  const datasource = field.fieldMetadata?.dataSource
  const dependentFieldId =
   dependentFieldMapping?.[field.fieldId]
  if (datasource && dependentFieldId) {
   const ddData = {...dropdownList}

   const clearDependentFieldData = (fieldId: any) => {
    const ddKey = props.parentId + '_' + fieldId
    const field = filterKeyValueMapping?.[fieldId]
    setValue(
     fieldId,
     getDefaultValue(field?.fieldMetadata?.inputType)
    )
    ddData[ddKey] = getDefaultValue(
     field?.fieldMetadata?.inputType
    )
    if (dependentFieldMapping?.[field.fieldId]) {
     clearDependentFieldData(
      dependentFieldMapping[field.fieldId]
     )
    }
   }

   clearDependentFieldData(dependentFieldId)
   const dependentField =
    filterKeyValueMapping[dependentFieldId]
   const ddKey =
    props.parentId + '_' + dependentField.fieldId

   const valueArr = dependentField.fieldMetadata?.dataSource
    ?.isMultiApiCall
    ? watch(field.fieldId)
    : [watch(field.fieldId)]

   const ddArr: any = []
   for (const value of valueArr) {
    const res: any = await fetchData(
     dependentField,
     field.fieldId,
     value
    )
    Array.prototype.push.apply(ddArr, res)
   }
   ddData[ddKey] = ddArr
   setDropdownList({...ddData})
  }
 }

 const populateField = (field: any) => {
  const labelName =
   field.label ?? field.fieldMetadata?.labelName
  const fieldId = field.fieldId
  const inputType = field.fieldMetadata.inputType
  const ddKey = props.parentId + '_' + field.fieldId
  switch (field.fieldMetadata.inputType) {
   case 'TEXT_FIELD': {
    return (
     <TextField
      type='text'
      disabled={props.isDisabled || field?.isDisabled}
      label={labelName}
      required={field.fieldMetadata?.isMandatory}
      wrapperClassName={'max-w-[350px]'}
      className='relative !text-base !font-medium !text-[#33393D]'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.fieldRegexError
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '')
            return `${t(
             'helperText.plsEnter'
            )} ${labelName}`
          },
         }),
        },
       }),
       onChange: () => {
        // checkForDependentFields(field)
       },
      })}
      placeholder={labelName}
      errors={errors}
     />
    )
   }
   case 'TEXTAREA_FIELD': {
    return (
     <TextareaField
      disabled={props.isDisabled || field?.isDisabled}
      rows={1}
      label={labelName}
      required={field.fieldMetadata?.isMandatory}
      labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
      className='relative !text-base !font-medium !text-[#33393D]'
      wrapperClassName='relative w-full col-span-2'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '')
            return `${t(
             'helperText.plsEnter'
            )} ${labelName}`
          },
         }),
        },
       }),
       onChange: () => {
        // checkForDependentFields(field)
       },
      })}
      placeholder={labelName}
      errors={errors}
     />
    )
   }
   case 'DROPDOWN':
   case 'MULTI_SELECT_DROPDOWN': {
    return (
     <Select2DropdownField
      disabled={props.isDisabled || field?.isDisabled}
      label={field.label}
      required={field.fieldMetadata?.isMandatory}
      isMultiselect={
       inputType == 'MULTI_SELECT_DROPDOWN' ? true : false
      }
      labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
      className={`${
       field.fieldMetadata?.isDisabled
        ? '!text-[#33393D]'
        : 'font-normal !text-[#33393D]'
      } !font-medium  relative block text-base border-0  !rounded-l-lg`}
      wrapperClassName='relative w-full'
      inputWrapperClassName='pl-4 py-2 px-4 '
      control={control}
      id={`${fieldId}`}
      name={`${fieldId}`}
      rules={{
       onChange: () => {
        void handleChange(field)
       },
      }}
      placeholder={labelName}
      data={dropdownList[ddKey] || []}
      OptionValueKey={
       field.fieldMetadata?.dataSource?.valueKey
      }
      OptionLabelKey={
       field.fieldMetadata?.dataSource?.labelKey
      }
      customStyle={{
       transition: 'unset',
       boxShadow: 'unset',
       border: '0px',
       borderRadius: '0px',
       padding: '0px 0px 0px 0px',
       minHeight: 'auto',
      }}
      errors={errors}
     />
    )
   }
   case 'RADIO_BTN':
   case 'CHECK_BOX': {
    return (
     <RadioButtonField
      disabled={props.isDisabled || field?.isDisabled}
      label={''}
      required={field.fieldMetadata?.isMandatory}
      type={inputType == 'RADIO_BTN' ? 'type' : 'checkbox'}
      wrapperClassName={'max-w-[350px]'}
      className='relative !text-base !font-medium !text-[#33393D]'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '')
            return `${t('helperText.plsEnter')}${labelName}`
          },
         }),
        },
       }),
       onChange: () => {
        // checkForDependentFields(field)
       },
      })}
      placeholder={labelName}
      data={dropdownList[ddKey] || []}
      OptionValueKey={
       field.fieldMetadata?.dataSource?.valueKey
      }
      OptionLabelKey={
       field.fieldMetadata?.dataSource?.labelKey
      }
      errors={errors}
     />
    )
   }

   case 'DATE_PICKER': {
    return (
     <DatePickerField
      disabled={props.isDisabled || field?.isDisabled}
      label={labelName}
      required={field.fieldMetadata?.isMandatory}
      wrapperClassName={'max-w-[350px]'}
      className='relative !text-base !font-medium !text-[#33393D] !p-0'
      control={control}
      popperClassName='!z-[50]'
      dateFormat='dd-MM-yyyy'
      id={`${fieldId}`}
      name={`${fieldId}`}
      rules={{
       onChange: () => {
        // handleChange(field)
       },
      }}
      maxDate={moment().toDate()}
      placeholder={field.fieldMetadata?.labelName}
      errors={errors}
     />
    )
   }
   case 'DATE_RANGE_PICKER': {
    return (
     <div className='w-full flex gap-2'>
      <DatePickerField
       disabled={props.isDisabled || field?.isDisabled}
       label={field.fieldMetadata?.labelName}
       required={field.fieldMetadata?.isMandatory}
       wrapperClassName={'max-w-[200px]'}
       className='relative !text-base !font-medium !text-[#33393D] !p-0'
       control={control}
       popperClassName='!z-[50]'
       dateFormat='dd-MM-yyyy'
       id={`${fieldId}`}
       name={`${fieldId}`}
       rules={{
        onChange: () => {
         // handleChange(field)
        },
       }}
       maxDate={
        watch(field.fieldMetadata?.toDateFieldId) ||
        moment().toDate()
       }
       placeholder={field.fieldMetadata?.labelName}
       errors={errors}
      />
      <DatePickerField
       label={field.fieldMetadata?.toDateFieldLabel}
       required={field.fieldMetadata?.isMandatory}
       wrapperClassName={'max-w-[200px]'}
       className='relative !text-base !font-medium !text-[#33393D] !p-0'
       control={control}
       popperClassName='!z-[50]'
       dateFormat='dd-MM-yyyy'
       id={`${field.fieldMetadata?.toDateFieldId}`}
       name={`${field.fieldMetadata?.toDateFieldId}`}
       rules={{
        onChange: () => {
         // handleChange(field)
        },
       }}
       minDate={watch(fieldId)}
       maxDate={moment().toDate()}
       placeholder={field.fieldMetadata?.toDateFieldLabel}
       errors={errors}
      />
     </div>
    )
   }

   case 'TOGGLE_FIELD': {
    return (
     <ToggleButtonField
      disabled={props.isDisabled || field?.isDisabled}
      type='text'
      label={labelName}
      desc={field?.description}
      required={field.fieldMetadata?.isMandatory}
      labelClassName='!text-[#33393D] !text-base !font-medium'
      descClassName='text-[#33393D] text-sm !font-medium'
      className='!w-10 !h-5 font-normal'
      btnClassName={`!h-3 !w-3`}
      wrapperClassName='relative w-full'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '')
            return `${t(
             'helperText.plsEnter'
            )} ${labelName}`
          },
         }),
        },
       }),
       onChange: () => {
        // checkForDependentFields(field)
       },
      })}
      watch={watch}
      setValue={setValue}
      placeholder={labelName}
      errors={errors}
     />
    )
   }

   case 'CHOICE_FIELD': {
    return (
     <ToggleButtonField
      disabled={props.isDisabled || field?.isDisabled}
      type='text'
      label={labelName}
      desc={field?.description}
      required={field.fieldMetadata?.isMandatory}
      moveBtnToEnd={true}
      labelPosition='start'
      iconPath={props?.toggleBtnIconList?.[fieldId]}
      labelClassName='!text-[#2F2F2F] !text-base !font-medium'
      descClassName='!text-[#33393D] text-xs !font-medium'
      className='!w-10 !h-5 font-normal'
      btnClassName={`!h-3 !w-3`}
      wrapperClassName='relative w-full'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '')
            return `${t('helperText.plsEnter')}${labelName}`
          },
         }),
        },
       }),
       onChange: () => {
        // checkForDependentFields(field)
       },
      })}
      watch={watch}
      setValue={setValue}
      placeholder={labelName}
      errors={errors}
     />
    )
   }
  }
 }

 useEffect(() => {
  reset({...props.formData})
 }, [props.formData])

 return (
  <div className='w-full'>
   <form action='' onSubmit={handleSubmit(applyFilter)}>
    <div className='w-full mt-7 inline-block'>
     <div className='float-left w-[250px] pb-2 text-[#33393D] text-base font-medium border-r-2 border-[#CCCCCC] pr-4 overflow-y-auto max-h-[300px]'>
      {props.filterConfig.map((v: any, i: any) => (
       <div key={i} className='w-100'>
        <div
         className={
          `w-100 flex justify-between items-center cursor-pointer rounded-lg bg-[#EDF3FC] hover:text-blue-600 hover:border-2 hover:border-blue-400 min-h-[50px]
          px-4 py-[14px]` +
          (props.filterConfig.length != i + 1
           ? ' mb-6 '
           : '') +
          (selectedBox === v.fieldId
           ? 'text-[#4E83E4] border border-[#4E83E4]'
           : '')
         }
         onClick={() => onChangeBox(v.fieldId)}
        >
         <div className=''>{v.fieldMenuName}</div>
         <div className='flex justify-center items-center'>
          {(v.key == 'timePeriod'
           ? props.formData?.startDate ||
             props.formData?.endDate
           : props.formData?.[v.key] &&
             (props.formData?.[v.key]?.length > 0 ||
              Object.keys(props.formData?.[v.key]).length >
               0)) && (
           <span className='border border-blue-400 rounded-full py-[5px] px-[9px] bg-blue-400 text-white text-xs'>
            {v.key == 'timePeriod' &&
            (props.formData?.startDate ||
             props.formData?.endDate)
             ? '1'
             : props.formData?.[v.key]?.length ??
               Object.keys(props.formData?.[v.key]).length}
           </span>
          )}
          <span className='fa fa-chevron-right pl-[10px]'></span>
         </div>
        </div>
       </div>
      ))}
     </div>
     <div
      className={`float-left w-[calc(100%-250px)] pl-4 `}
     >
      {filterKeyValueMapping &&
       props.filterConfig.map((v: any, i: any) => (
        <div key={i} hidden={selectedBox !== v.fieldId}>
         <div className='pb-4 text-xl font-medium text-[#33393D]'>
          {`${t('helperText.select')}`} {v.fieldMenuName}
         </div>
         {populateField(v)}
        </div>
       ))}
     </div>
    </div>

    <div className='text-left mt-4 flex gap-3'>
     <Button
      type='button'
      disabled={false}
      color='blue'
      onClick={clearAllFilters}
      className='disabled:text-white text-center flex-1 py-[9px] px-6 bg-[#4E83E4] 
                                  !rounded-lg !text-base text-white font-semibold border-[#4E83E4]'
     >
      {t('common.clearAll')}
     </Button>
     <Button
      type={'submit'}
      disabled={false}
      color='blue'
      className='disabled:text-white text-center flex-1 py-[9px] px-6 bg-[#4E83E4] 
                                  !rounded-lg !text-base text-white font-semibold border-[#4E83E4]'
     >
      {t('common.next')}
     </Button>
    </div>
   </form>
  </div>
 )
}

export default GenericFilters
